import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { clampTokenUsagePercentage } from '~/components/chat/components/token-usage-utils';

import styles from './TokenUsageControl.module.scss';

export interface TokenUsagePopoverProps {
  percentage: number;
  resetDate?: string;
}

export const TokenUsagePopover = ({
  percentage,
  resetDate,
}: TokenUsagePopoverProps) => {
  const { t } = useTranslation('chat');
  const clampedPercentage = clampTokenUsagePercentage(percentage);

  return (
    <div className={styles.popover}>
      <div className={styles.usage}>
        <div className={styles.popoverTitle}>
          <span>{t('chat:tokenUsage.popoverTitle')}</span>
          <span className={styles.popoverPercentage}>
            {t('chat:tokenUsage.percentage', {
              percentage: clampedPercentage,
            })}
          </span>
        </div>
        <div
          className={styles.gauge}
          data-testid="token-usage-gauge"
          role="progressbar"
          aria-label={t('chat:tokenUsage.percentageLabel', {
            percentage: clampedPercentage,
          })}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={clampedPercentage}
        >
          <span
            className={clsx(
              styles.gaugeValue,
              clampedPercentage >= 90 && styles.criticalGaugeValue
            )}
            style={{ width: `${clampedPercentage}%` }}
          />
        </div>
      </div>
      <p className={styles.popoverMessage}>
        {resetDate && (
          <span>{t('chat:tokenUsage.resetDate', { resetDate })}</span>
        )}
        <span>{t('chat:tokenUsage.extendAccess')}</span>
      </p>
    </div>
  );
};
